// Flood control for browser logs: collapse identical (digit-masked) messages to
// once per minute, and hard-cap total emits per rolling minute. Shared across the
// console, window-error and HTTP loggers so a single noisy source can't flood Loki.
const DEDUPE_MS = 60_000;
const MAX_PER_MIN = 120;

const seen = new Map<string, number>();
let windowStart = Date.now();
let windowCount = 0;

export function allowLog(key: string): boolean {
  const now = Date.now();
  if (now - windowStart >= 60_000) {
    windowStart = now;
    windowCount = 0;
  }
  if (windowCount >= MAX_PER_MIN) return false; // distinct-message flood cap
  const k = key.replace(/\d+/g, '#').slice(0, 160); // mask digits so timestamps/ids collapse
  const last = seen.get(k);
  if (last && now - last < DEDUPE_MS) return false;
  seen.set(k, now);
  if (seen.size > 200) seen.clear(); // bound memory
  windowCount++;
  return true;
}
